import KeenSlider from "keen-slider";

function pdpMobGallaryNav(slider) {
  let wrapper, arrowLeft, arrowRight;

  const observer = new ResizeObserver(function () {
    slider.update();
  });

  function markup(remove) {
    wrapperMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createDiv("arrow arrow--left");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowRight = createDiv("arrow arrow--right");
    arrowRight.addEventListener("click", () => slider.next());

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("navigation-wrapper");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
  }

  slider.on("created", (e) => {
    markup();
    updateClasses();
    observer.observe(slider.container);
  });
  slider.on("optionsChanged", () => {
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
    observer.observe(slider.container);
  });
}

var mobGallaryEle = document.querySelector("#pdp_gallary_mob");
if (mobGallaryEle) {
  var slider = new KeenSlider(
    mobGallaryEle,
    {
      loop: true,
      rtl: window.rtlView,
      breakpoints: {
        "(min-width: 768px)": {
          disabled: true,
        },
      },
    },
    [pdpMobGallaryNav]
  );
}

const wearWithCtaEle = document.querySelector(".pdp-wear-with");
if (wearWithCtaEle) {
  let wearWithCloseEle = document.querySelector(".wear-it-with-close");

  wearWithCtaEle.addEventListener("click", () => wearWithVisiblity(true));
  wearWithCtaEle.addEventListener("mouseover", () => wearWithVisiblity(true));
  wearWithCloseEle.addEventListener("click", () => wearWithVisiblity(false));

  /**
   * Control Visibility of wear it with Desktop
   * @param {boolean} status - Whether show(true) or hide(false) wear it with products container.
   */
  function wearWithVisiblity(status) {
    let wearWithContainEle = document.querySelector(".wear-with-container");
    if (status) {
      wearWithContainEle.classList.add("active");
    } else {
      wearWithContainEle.classList.remove("active");
    }
  }
}
